import { Component, OnInit } from '@angular/core';
import {DataserviceService} from '../../dataservice.service';

  
  


@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  basePath:String;
  slideConfig1 = {
  
    
    slidesPerRow:1,
  

    centerMode:true
    
  }
  slideConfig2 = {
    slidesPerRow:2,
    centerMode:true,
    centerPadding: '60px'
  }


  slideConfig3 = {
    slidesPerRow:3,
    slidesToScroll: 1,
    centerPadding: '60px',
    dots:true,
   

  }

  slideConfig = {
    infinite: true,

    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 8000,
    dots:true,
    centerMode: true,

centerPadding: '60px',

arrows: true,
responsive: [


  

  {
    breakpoint: 992,
    settings: {
      arrows: true,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 2
    }
  },

  {
    breakpoint: 768,
    settings: {
      arrows: true,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1
    }
  },

  {
    breakpoint: 480,
    settings: {
      arrows: true,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1
    }
  }
]
};


  slickInit(e) {
    console.log('slick initialized');
  }
  
  breakpoint(e) {
    console.log(e);
    
    console.log('breakpoint');
   
  }
  
  afterChange(e) {
    console.log('afterChange');
  }
  
  beforeChange(e) {
    console.log('beforeChange');
  }









  show_local_array:Object[];
  show_social_array:Object[]

  constructor(private dataservice:DataserviceService) { }

  ngOnInit() {

    this.basePath="http://18.224.22.40:3000/api/upload?filename=";




    this.dataservice.getUpdate().subscribe(
      data =>{
        console.log(data);
        this.show_local_array=data.local;
       
        this.show_social_array=data.social;
if(this.show_local_array.length == 2){

        $('.slick-slide.slick-current.slick-active.slick-center')
}
       
        
      }
    )


  }

}
